var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7.95178 6.29433L9.99999 1.57098L12.0482 6.29433C12.1967 6.63684 12.5197 6.87151 12.8914 6.90692L18.0165 7.39529L14.1572 10.8028C13.8774 11.0499 13.754 11.4296 13.8352 11.794L14.9545 16.8192L10.5211 14.2019C10.1996 14.0121 9.80037 14.0121 9.47889 14.2019L5.04554 16.8192L6.16482 11.794C6.24598 11.4296 6.12261 11.0499 5.84276 10.8028L1.98352 7.39529L7.10862 6.90692C7.48026 6.87151 7.80326 6.63684 7.95178 6.29433Z",
    stroke: "white",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarUnchecked);
export default __webpack_public_path__ + "static/media/star_unchecked.c573681a8c8b35e2135e0594c273279d.svg";
export { ForwardRef as ReactComponent };